/**
 * sessionStorage prefix for QA force-overrides. Exported so consumers and the
 * logout cleanup agree on one spelling.
 */
export const EXPERIMENT_FORCE_PREFIX = 'experiment-force:';
const STORAGE_PREFIX = EXPERIMENT_FORCE_PREFIX;

/**
 * QA-only escape hatch for the experiment seam — lets internal testers force a
 * specific arm for ANY decider experiment via `?force_variant_<key>=<arm>`
 * (e.g. `?force_variant_add-screen-cta-v1=treatment`). Persisted to sessionStorage per key
 * so subsequent navigations stay on the forced arm for the session.
 *
 * **Honored only in non-production** so it can never leak into prod experiment
 * metrics. With no param and no stored value it returns `null` →
 * `useExperimentVariant` falls through to the real decider, so normal users (no
 * param) are completely unaffected. Works for every decider experiment.
 */
export function readForcedVariant(key: string): string | null {
  if (typeof window === 'undefined') return null;
  if (import.meta.env.VITE_POSTHOG_ENVIRONMENT === 'production') return null;

  const storageKey = `${STORAGE_PREFIX}${key}`;
  const param = new URL(window.location.href).searchParams.get(`force_variant_${key}`);
  if (param) {
    sessionStorage.setItem(storageKey, param);
    console.warn(`[experiment] QA override: forcing ${key}=${param}`);
    return param;
  }

  const stored = sessionStorage.getItem(storageKey);
  return stored && stored.length > 0 ? stored : null;
}
